import { Routes } from "@angular/router";

//Components
import { CreateUserComponent } from "./create-user/create-user.component";
import { UserManagementComponent } from "../admin/user-management/user-management.component";
import { CreateSuccessComponent } from "./create-user/create-success.component";
import { EditUserComponent } from "./edit-user/edit-user.component";
import { EditSuccessComponent } from "./edit-user/edit-success.component";


export const ADMIN_ROUTES: Routes = [
  { path: "create-user", component: CreateUserComponent },
  { path: "create-success", component: CreateSuccessComponent },
  { path: "edit-user/:id", component: EditUserComponent },
  { path: "edit-success", component: EditSuccessComponent },
  {
    path: "user-management",
    component: UserManagementComponent,
    data: {
      admin: true,
      title: "Gestión de Usuario",
      backUrl: "/pages/home/user-management",
    },
  },
];
